import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AuthState } from "../types/appointmentType";

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      isAuthenticated: !!localStorage.getItem("token"),
      isLoading: true,
      user: null,
      isRegistred: !!localStorage.getItem("token"), // If they have a token, they're registered
      validateToken: async () => {
        const token = localStorage.getItem("token");

        if (!token) {
          set({
            isAuthenticated: false,
            isLoading: false,
            user: null,
            // We don't change isRegistred here
          });
          return false;
        }
        set({
          isAuthenticated: true,
          isLoading: false,
          isRegistred: true, // If they have a token, they're registered
        });
        return true;
      },

      setIsAuthenticated: (isAuthenticated: boolean) => {
        set({
          isAuthenticated,
          // If they're authenticated, they must be registered
          isRegistred: isAuthenticated ? true : get().isRegistred,
        });
      },

      setIsLoading: (isLoading: boolean) => {
        set({ isLoading });
      },

      setUser: (user) => {
        set({
          user,
          // If user data exists, they must be registered
          isRegistred: user ? true : get().isRegistred,
        });
      },

      setIsRegistred: (isRegistred: boolean) => {
        set({ isRegistred });
      },

      clearUser: () => {
        set({
          isAuthenticated: false,
          user: null,
          isLoading: false,
        });
      },

      logout: () => {
        localStorage.removeItem("token");
        localStorage.removeItem("idToken");
        localStorage.removeItem("refreshToken");
        set({
          isAuthenticated: false,
          user: null,
          isLoading: false,
        });
      },
    }),
    {
      name: "auth-store",
      storage: {
        getItem: async (name: string) => {
          const item = localStorage.getItem(name);
          return item ? JSON.parse(item) : null;
        },
        setItem: async (name: string, value: unknown) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: async (name: string) => {
          localStorage.removeItem(name);
        },
      },
    }
  )
);
